import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios-default';

import user from './modules/user'
import controllers from './modules/controllers'
import notifications from './modules/notifications'
import users from './modules/users'
import alerts from './modules/alerts'
import temperature from './modules/temperature'
//import controller from './modules/controller'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: {
      visible: false,
      color: "success",
      text: null,
      timeout: 10000,
      multiline: false,
      ok: false
    }
  },
  mutations: {
    alert(state, payload) {
      state.snackbar.text = payload.text;
      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline;
      } else {
        state.snackbar.multiline = payload.text.length > 50;
      }
      if (payload.color) {
        state.snackbar.color = payload.color;
      }
      if (payload.timeout) {
        state.snackbar.timeout = payload.timeout;
      }
      if (payload.ok) {
        state.snackbar.ok = payload.ok;
      }
      state.snackbar.visible = true;
    },
    closeAlert(state) {
      state.snackbar.visible = false;
      state.snackbar.multiline = false;
      state.snackbar.text = null;
      state.snackbar.ok = false;
    },
  },
  modules: {
    user,
    controllers,
    notifications,
    alerts,
    users,
    temperature
  }
})
